"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var layout_1 = require("../../components/layout");
var Step_1 = require("./Step");
var styles_1 = require("./styles");
var ORIENTATION = {
    H: 'horizontal',
    V: 'vertical',
    VC: 'vertical-card',
};
var TYPE = (_a = {},
    _a[ORIENTATION.H] = Step_1.HorizontalStep,
    _a[ORIENTATION.V] = Step_1.VerticalStep,
    _a[ORIENTATION.VC] = Step_1.VerticalCardStep,
    _a);
var Stepper = function (_a) {
    var _b = _a.steps, steps = _b === void 0 ? [] : _b, activeStep = _a.activeStep, _c = _a.orientation, orientation = _c === void 0 ? 'horizontal' : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, onStepSelected = _a.onStepSelected;
    var theme = react_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.createStyles(theme); }, [theme]);
    var isVertical = orientation !== ORIENTATION.H;
    var isVerticalCard = orientation === ORIENTATION.VC;
    var renderStep = function (step, index) {
        var isCurrentStep = index === activeStep;
        var isLast = index === steps.length - 1;
        var isActive = step.completed && index === activeStep;
        var StepComponent = TYPE[orientation];
        return (react_1.jsx(layout_1.Flex, { css: [
                styles.stepContainer(isVerticalCard ? false : !(step.completed || isCurrentStep)),
                styles.stepDisabled(step.disabled),
            ], onClick: function () { return onStepSelected === null || onStepSelected === void 0 ? void 0 : onStepSelected(index); }, key: index },
            react_1.jsx(StepComponent, __assign({ isCompleted: Boolean(step.completed), isCurrentStep: isCurrentStep, isLast: isLast, activeStep: activeStep, index: index, styles: styles, size: size, isActive: isActive }, step))));
    };
    return (react_1.jsx(layout_1.Flex, { direction: isVertical ? 'column' : 'row', alignItems: "flex-start" }, steps.map(renderStep)));
};
Stepper.displayName = 'ProgressSteps';
exports.default = Stepper;
